import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(legacy)/topics/$id')({
	loader: ({ params }) => {
		throw redirect({
			to: '/topic/$id',
			replace: true,
			params,
		})
	},
})
